module.exports = __webpack_public_path__ + "img/item4.41edff7f.png";